import { DisabledPrompt, Link, useRoute, useWorkflow } from "@bcm-dev/bcms-vite";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow } from "components/shared/containers/FormContainer";
import { UIButton, UINumberInput } from "components/ui";
import { SVGAsset } from "res";

import "./styles.css";

export default function VerifyRecipientContent(props) {
    const navigate = useRoute();
    const workflow = useWorkflow();

    const { recipient } = workflow.state ?? {};

    const onBack = evt => workflow.prevStep();
    const onVerify = () => navigate("/advancedAlerts/manageRecipients", { state: { verified: true } })

    return (
        <div className="verify-recipient-content back-link-padding">
            <Link className="back-link" onClick={ onBack }>
                <span><SVGAsset id="LeftChevronIcon" /> Back</span>
            </Link>

            <p className="page-subtitle">Verify Recipient</p>

            <FormContainer className="small-form-width-wrapper">
                <FormRowView className="verification-msg">
                    <p>We sent a verification code to { recipient }. Please enter the code.</p>
                </FormRowView>

                <div className="small-form-width">
                    <FormRowView text="Verification Code *">
                        <UINumberInput />
                    </FormRowView>

                    <FormButtonRow>
                        <DisabledPrompt>
                            <UIButton className="primary-button" text="Resend Code" />
                        </DisabledPrompt>

                        <UIButton className="primary-button" text="Verify" onClick={ onVerify } />
                    </FormButtonRow>
                </div>
            </FormContainer>
        </div>
    );
}